export default __webpack_public_path__ + "static/media/tesla.3b6c6e32.jpeg";